import React, { useEffect, useState } from "react"
import useServerSort from "../../../helpers/useServerSort"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import { searchCentralStoreProductList } from "../../../services/centralStore/centralStore"
import ProductFilter from "./filter"
import NumberFormat from "../../../utils/numberFormat"

const ProductList = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Products List${companyname ? ` | ${companyname}` : ''}`;

  const [page, setPage] = useState("")
  const [productList, setProductList] = useState("")
  const [count, setCount] = useState(0)
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")

  const { sortParam, handleServerSort } = useServerSort(() => setPage(1))
  useEffect(() => {
    const fetchData = async () => {
      const response = await searchCentralStoreProductList({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${page ? `&page=${page}` : ""}${sortParam}${`&sizePerPage=16`}`,
      })
      setProductList(response)
    }
    fetchData()
  }, [count, status, search, page, sortParam])

  const columns = [
    {
      label: "Product Code",
      sortKey: "product_code",
      renderCell: item =>
        item?.product_id?.product_code ? item?.product_id?.product_code : "-",
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => <div className="text-end pe-5">{NumberFormat((Number(item?.quantity)))}</div>,
    },
    {
      label: "Project Name",
      renderCell: item =>
        item?.project?.project_name ? item?.project?.project_name : "-",
    },
    {
      label: "Location",
      renderCell: item =>
        item?.project?.location?.name ? item?.project?.location?.name : "-",
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content tnt-scope">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Procurement"
              breadcrumbObject={[
                { title: "Procurement", link: "/procurement" },
                { title: "Products List", link: "/procurement/product-list" },
              ]}
            />
          </div>
          <Card className="me-2 px-2 pb-2 main-dashboard-bg">

            <ProductFilter
              handleSearchChange={handleSearchChange}
              placeholder="Search"
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {productList?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={productList?.data}
                    paginate={productList}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    handleServerSort={handleServerSort}
                    tableWidth="25% 25% 25% 25%"
                    mobileWidth="50% 50% 50% 50%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}
export default ProductList
